import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SelvedgeColourReferenceService extends BaseReferenceService {
  constructor() {
    super('SelvedgeColourReference');
  }
}
